import {
  DesignModelFileKind,
  missingFilesSentence,
} from 'src/routes/Jobs/DesignModels/designModelFiles';

export interface IReprocessGateInput {
  isCreate: boolean;
  /** A save or a reprocess request is in flight. */
  pending: boolean;
  conversionStatus: string | null | undefined;
  dirty: boolean;
  uploading: boolean;
  missing: DesignModelFileKind[];
  hasSavedIfc: boolean;
}

export interface IReprocessBlock {
  display: 'hidden' | 'loading' | 'disabled';
  reason?: string;
}

/** Null means Reprocess is enabled; otherwise the first matching rule decides how the button renders and why. */
export const getReprocessBlockReason = ({
  isCreate,
  pending,
  conversionStatus,
  dirty,
  uploading,
  missing,
  hasSavedIfc,
}: IReprocessGateInput): IReprocessBlock | null => {
  if (isCreate) return { display: 'hidden' };
  if (pending) return { display: 'loading' };
  if (conversionStatus === 'Processing')
    return { display: 'disabled', reason: 'Processing is already running.' };
  if (dirty)
    return {
      display: 'disabled',
      reason:
        'Save or discard your changes first. Saving file changes reprocesses automatically.',
    };
  if (uploading)
    return { display: 'disabled', reason: 'Wait for the upload to finish.' };
  if (missing.length > 0)
    return { display: 'disabled', reason: missingFilesSentence(missing) };
  if (!hasSavedIfc)
    return { display: 'disabled', reason: 'Add an IFC file and save first.' };
  return null;
};
